module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-nav"
  }, [(_vm.mold === 'navBottom') ? _c('div', {
    staticClass: "navBottom"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegisterView'
      }
    }
  }, [_vm._v("注册帐号")]), (_vm.currentUser.email) ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      },
      "replace": ""
    }
  }, [_vm._v("登录豆瓣")])]], 2), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.mold === 'quickNav') ? _c('div', {
    staticClass: "quickNav"
  }, [_c('ul', {
    staticClass: "quick-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MovieView'
      }
    }
  }, [_vm._v("影院热映")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'StatusView'
      }
    }
  }, [_vm._v("欧美新碟榜")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegisterView'
      }
    }
  }, [_vm._v("注册帐号")])], 1), _vm._v(" "), _c('li', [(_vm.currentUser.email) ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      },
      "replace": ""
    }
  }, [_vm._v("登录豆瓣")])]], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://movie.douban.com/"
    }
  }, [_vm._v("使用桌面版")]), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("使用豆瓣App")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121070d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubNav.vue
// module id = 190
// module chunks = 0